import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, Input } from "@angular/core";

import { BaseComponent, UserService, environment, WindowService, ProductService, HelperService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ScriptService } from "@mypxplat/xplat/web/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Router } from "@angular/router";

declare var Stripe;

@Component({
  selector: "myp-update-payment-source-stripe",
  templateUrl: "update-payment-source-stripe.component.html",
})
export class UpdatePaymentSourceStripeComponent extends BaseComponent implements OnInit {
  public stripe: any;
  @ViewChild("cardNumber") cardNumberElement: ElementRef;
  @ViewChild("cardExpiry") cardExpiryElement: ElementRef;
  @ViewChild("cardCVC") cardCVCElement: ElementRef;
  public cardNumber: any;
  public cardExpiry: any;
  public cardCVC: any;
  public valid: any = {
    cardNumber: false,
    cardExpiry: false,
    cardCVC: false,
  };

  @Input() userCountry: string;
  @Input() isTaxInclusive: string;
  @Input() isBlueSnapSubscription: boolean;
  @Input() selectedPlan: string;
  @Input() currency: string;

  public isValidCard() {
    return Object.values(this.valid).every((v) => v === true) && Object.values(this.billingInfo).every((b) => !!b);
  }
  public isDifferentAddress() {
    if (this.taxedBillingInfo) {
      return Object.keys(this.billingInfo).some((key) => this.billingInfo[key] !== this.taxedBillingInfo[key]);
    }
    return true;
  }
  public loading: boolean = true;
  public fieldsReady: boolean = false;
  public error: string;
  public billingInfo: any = {
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  };
  public taxedBillingInfo: any;
  public countries: Array<any>;
  public states: Array<any>;
  public canadianProvinces: Array<any>;
  public indianStates: Array<any>;
  public subscriptionId: string;
  public clientSecret: string;
  public loadingMsg: string;
  public spherePrices: {
    monthly: {
      id: string;
      price: number;
      currency: string;
      formatted_price: string;
      tax: number;
      tax_rate?: number;
    };
    annual: {
      id: string;
      price: number;
      currency: string;
      formatted_price: string;
      tax: number;
      tax_rate?: number;
    };
  };
  public priceList: any;
  public isConverted: boolean;
  public supportedCurrencies: any = [];
  public isTaxCalculated: boolean = false;
  public taxDetails: any;
  public totalCharge: number;
  public taxCalulated: number;
  public activeCurrency: string;

  public isNoDecimalCurrency(currency) {
    if (currency) {
      return environment.stripe.no_decimal_currencies.includes(currency.toUpperCase());
    }
    return false;
  }
  public isCurrencySupported(currency) {
    if (this.supportedCurrencies && this.supportedCurrencies.length && currency) {
      return this.supportedCurrencies.includes(currency);
    }
    return false;
  }

  public totalAmountPayable() {
    return Number((this.totalCharge && !(this.isConverted || this.billingInfo.country === "US" ? false : true) ? this.totalCharge : this.spherePrices[this.selectedPlan].price).toFixed(2));
  }

  @Output() cardAdded: EventEmitter<void> = new EventEmitter();

  constructor(
    private _win: WindowService,
    public userService: UserService,
    public activeModal: NgbActiveModal,
    public productService: ProductService,
    private _scriptService: ScriptService,
    public fbAuth: AngularFireAuth,
    public router: Router,
    public helperService: HelperService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loadStripeElements();
    this.userService.listCountries().subscribe((result) => {
      this.countries = [];
      for (var i in result) {
        this.countries.push({
          title: result[i],
          code: i,
        });
      }
      this.billingInfo.country = this.userCountry || "US";
    });
    this.userService.listStates().subscribe((result) => {
      this.states = [];
      for (var i in result) {
        this.states.push({
          title: result[i],
          code: i,
        });
      }
    });
    this.canadianProvinces = [];
    for (var c in this.userService.canadianProvinces) {
      this.canadianProvinces.push({
        title: this.userService.canadianProvinces[c],
        code: c,
      });
    }

    this.indianStates = [];
    for (var c in this.userService.indianStates) {
      this.indianStates.push({
        title: this.userService.indianStates[c],
        code: c,
      });
    }
    if (this.isBlueSnapSubscription) {
      this.billingInfo.country = this.userCountry;
      this.countryChange();
      this.loadPrices();
    }
  }

  loadStripeElements() {
    var elementStyles = {
      base: {
        color: this.themeImage == "auto" ? (window.matchMedia("(prefers-color-scheme: light)").matches ? "#333" : "white") : this.themeImage == "plainlight" ? "#333" : "white",
        "::placeholder": {
          color: this.themeImage == "auto" ? (window.matchMedia("(prefers-color-scheme: light)").matches ? "gray" : "#cfd7dfd1") : this.themeImage == "plainlight" ? "gray" : "#cfd7dfd1",
        },
        ":-webkit-autofill": {
          color: this.themeImage == "auto" ? (window.matchMedia("(prefers-color-scheme: light)").matches ? "#333" : "white") : this.themeImage == "plainlight" ? "#333" : "white",
        },
      },
    };
    this.stripe = Stripe(environment.stripe.public_key);
    const elements = this.stripe.elements();

    this.cardNumber = elements.create("cardNumber", {
      showIcon: true,
      iconStyle: "solid",
      style: elementStyles,
      placeholder: "1234 5678 9012 3456",
    });

    this.cardExpiry = elements.create("cardExpiry", {
      style: elementStyles,
    });

    this.cardCVC = elements.create("cardCvc", {
      style: elementStyles,
      placeholder: "123",
    });

    setTimeout(() => {
      this.cardNumber.mount(this.cardNumberElement.nativeElement);
      this.cardExpiry.mount(this.cardExpiryElement.nativeElement);
      this.cardCVC.mount(this.cardCVCElement.nativeElement);
      this.loading = false;
      this.fieldsReady = true;
    }, 3000);

    this.cardNumber.addEventListener("change", (response) => {
      if (response.complete) {
        this.valid.cardNumber = true;
        if (this.valid.cardCVC && this.valid.cardExpiry) {
          this.setChargedMessage();
        }
      }
    });
    this.cardExpiry.addEventListener("change", (response) => {
      if (response.complete) {
        this.valid.cardExpiry = true;
        if (this.valid.cardCVC && this.valid.cardNumber) {
          this.setChargedMessage();
        }
      }
    });
    this.cardCVC.addEventListener("change", (response) => {
      if (response.complete) {
        this.valid.cardCVC = true;
        if (this.valid.cardNumber && this.valid.cardExpiry) {
          this.setChargedMessage();
        }
      }
    });
  }

  countryChange() {
    if (this.userCountry && this.userCountry !== this.billingInfo.country) {
      alert("You are not allowed to select a different country than your current subscribed country.");
      setTimeout(() => {
        this.billingInfo.country = this.userCountry;
      }, 50);
    } else {
      if (this.billingInfo.country == "US") {
        this.billingInfo.state = "AL";
      } else if (this.billingInfo.country == "CA") {
        this.billingInfo.state = "AB";
      } else if (this.billingInfo.country == "IN") {
        this.billingInfo.state = "AP";
      } else {
        delete this.billingInfo.state;
      }
    }
  }

  loadPrices() {
    this.userService.getSpherePricesStripe(this.isBlueSnapSubscription).subscribe(
      (result: any) => {
        if (result.success && result.data) {
          if (result.data.prices) {
            let subscriptionPrices = result.data.prices.filter((p) => p.product === environment.stripe.subscription_product.monthly || p.product === environment.stripe.subscription_product.annual);
            this.priceList = subscriptionPrices;
            this.supportedCurrencies = result.data.supported_currencies || [];
            let filteredPrices = subscriptionPrices.filter((p) => p.currency.toLowerCase() === this.currency.toLowerCase());
            if (filteredPrices && filteredPrices.length) {
              this.isConverted = false;
              let newPrices: any = {};
              filteredPrices.map((price) => {
                if (price.recurring.interval === "year") {
                  newPrices.annual = {
                    id: price.id,
                    price: this.isNoDecimalCurrency(price.currency) ? price.unit_amount : price.unit_amount / 100,
                    currency: price.currency,
                    formatted_price: null,
                    tax: null,
                    tax_rate: null,
                  };
                } else if (price.recurring.interval === "month") {
                  newPrices.monthly = {
                    id: price.id,
                    price: this.isNoDecimalCurrency(price.currency) ? price.unit_amount : price.unit_amount / 100,
                    currency: price.currency,
                    formatted_price: null,
                    tax: null,
                    tax_rate: null,
                  };
                }
              });
              this.spherePrices = newPrices;
              this.activeCurrency = newPrices.annual.currency;
            } else if (this.currency && this.isCurrencySupported(this.currency.toLowerCase())) {
              let basePrices = this.priceList.filter((p) => p.currency === "usd");

              let currencyData = {
                currency_code: this.currency,
                convert: [],
              };
              if (basePrices && basePrices.length) {
                basePrices.map((price) => {
                  currencyData.convert.push({
                    from: "usd",
                    value: (price.unit_amount / 100).toFixed(2),
                    interval: price.recurring.interval,
                  });
                });

                this.userService.currencyConvert(currencyData).subscribe((result: any) => {
                  if (result.success && result.data.every((c) => c.valid === true)) {
                    this.isConverted = true;
                    let newPrices: any = {};
                    result.data.map((price) => {
                      if (price.interval === "year") {
                        newPrices.annual = {
                          id: "converted_" + price.interval,
                          price: this.isNoDecimalCurrency(price["to-type"]) ? parseInt(price["result-float"]) : Number(price["result-float"].toFixed(2)),
                          currency: price["to-type"],
                          formatted_price: null,
                          tax: null,
                          tax_rate: null,
                        };
                      } else if (price.interval === "month") {
                        newPrices.monthly = {
                          id: "converted_" + price.interval,
                          price: this.isNoDecimalCurrency(price["to-type"]) ? parseInt(price["result-float"]) : Number(price["result-float"].toFixed(2)),
                          currency: price["to-type"],
                          formatted_price: null,
                          tax: null,
                          tax_rate: null,
                        };
                      }
                    });
                    this.spherePrices = newPrices;
                    this.activeCurrency = newPrices.annual.currency;
                  } else {
                    this.loadDefaultPrices();
                  }
                });
              }
            } else {
              this.loadDefaultPrices();
            }
          }
        }
      },
      (error) => {}
    );
  }

  loadDefaultPrices() {
    let basePrices = this.priceList.filter((p) => p.currency === "usd");
    this.isConverted = false;
    let newPrices: any = {};
    basePrices.map((price) => {
      if (price.recurring.interval === "year") {
        newPrices.annual = {
          id: price.id,
          price: price.unit_amount / 100,
          currency: price.currency,
          formatted_price: null,
          tax: null,
          tax_rate: null,
        };
      } else if (price.recurring.interval === "month") {
        newPrices.monthly = {
          id: price.id,
          price: price.unit_amount / 100,
          currency: price.currency,
          formatted_price: null,
          tax: null,
          tax_rate: null,
        };
      }
    });
    this.spherePrices = newPrices;
    this.activeCurrency = newPrices.annual.currency;
  }

  validateForm() {
    if (this.isValidCard() && this.isDifferentAddress()) {
      this.setChargedMessage();
    }
  }

  setChargedMessage() {
    if (this.isValidCard()) {
      this.isTaxCalculated = false;
      let selectedPrice = this.spherePrices[this.selectedPlan].price;

      let taxData = {
        lines: [
          {
            number: 1,
            quantity: 1,
            amount: selectedPrice.toFixed(2),
            taxCode: environment.tax.tax_code,
            taxIncluded: this.isConverted || this.billingInfo.country === "US" ? false : true,
          },
        ],
        date: new Date().toISOString().split("T")[0],
        customerCode: environment.tax.customer_code,
        address: {
          line1: this.billingInfo.address,
          city: this.billingInfo.city,
          region: this.billingInfo.state,
          country: this.billingInfo.country,
          postalCode: this.billingInfo.zip,
        },
        currencyCode: this.activeCurrency,
      };

      this.userService.calculateTax(taxData).subscribe(
        (result: any) => {
          if (result) {
            this.taxedBillingInfo = { ...this.billingInfo };
            this.taxDetails = result;
            this.taxCalulated = result.totalTaxCalculated;
            if (!(this.isConverted || this.billingInfo.country === "US" ? false : true)) {
              this.totalCharge = Number((selectedPrice + this.taxCalulated).toFixed(2));
            } else {
              this.totalCharge = 0;
            }
            this.isTaxCalculated = true;
          }
        },
        (error) => {
          this.taxCalulated = 0;
          this.isTaxCalculated = false;
          this.error = this.helperService.retrieveErrorMessage(error);
        }
      );
    }
  }

  submit() {
    if (this.isValidCard()) {
      this.loading = true;
      this.loadingMsg = "Please wait while we are setting up your new card...";
      this.stripe
        .createPaymentMethod({
          type: "card",
          card: this.cardNumber,
          billing_details: {
            name: this.billingInfo.firstName + " " + this.billingInfo.lastName,
          },
        })
        .then((response) => {
          if (response.paymentMethod) {
            //If card country doesn't match with user location
            if (this.userCountry && this.userCountry !== response.paymentMethod.card.country) {
              this.loading = false;
              this.error = "You are not allowed to add a card from different country than your current subscribed country.";
            } else {
              let paymentMethod = {
                address: {
                  line1: this.billingInfo.address,
                  city: this.billingInfo.city,
                  state: this.billingInfo.state,
                  country: this.billingInfo.country,
                  postal_code: this.billingInfo.zip,
                },
                is_tax_inclusive: this.isTaxInclusive,
              };
              this.userService.getCardClientSecret(paymentMethod).subscribe(
                (result: any) => {
                  if (result && result.success && result.data) {
                    this.clientSecret = result.data.client_secret;
                    this.stripe
                      .confirmCardSetup(result.data.client_secret, {
                        payment_method: {
                          card: this.cardNumber,
                          billing_details: {
                            name: this.billingInfo.firstName + " " + this.billingInfo.lastName,
                          },
                        },
                      })
                      .then((response) => {
                        if (response.setupIntent) {
                          //TODO: Call API to change card
                          this.userService.updatePaymentMethod({ payment_method: response.setupIntent.payment_method }).subscribe(
                            (result: any) => {
                              if (result.success) {
                                this.cardAdded.next();
                                this.loading = false;
                                this.activeModal.close();
                              } else {
                                this.loading = false;
                                this.error = "Please double check your credit card info.";
                              }
                            },
                            (error) => {
                              this.loading = false;
                              this.error = this.helperService.retrieveErrorMessage(error);
                            }
                          );
                        } else {
                          this.loading = false;
                          this.error = "Please double check your credit card info.";
                        }
                      })
                      .catch((err) => {
                        this.loading = false;
                        this.error = "Please double check your credit card info.";
                      });
                  }
                },
                (error) => {
                  this.loading = false;
                  this.error = this.helperService.retrieveErrorMessage(error);
                }
              );
            }
          }
        });
    } else {
      this.loading = false;
      this.error = "Please fill out all required fields and double check your credit card info.";
    }
  }

  switchToStripeSubscription() {
    if (this.isValidCard()) {
      this.loading = true;
      this.loadingMsg = "Please wait while your payment is being processed...";
      this.stripe
        .createPaymentMethod({
          type: "card",
          card: this.cardNumber,
          billing_details: {
            name: this.billingInfo.firstName + " " + this.billingInfo.lastName,
          },
        })
        .then((response) => {
          if (response.paymentMethod) {
            //If card country doesn't match with user location
            if (this.userCountry && this.userCountry !== response.paymentMethod.card.country) {
              this.loading = false;
              this.error = "You are not allowed to add a card from different country than your current subscribed country.";
            } else {
              if (this.clientSecret && this.subscriptionId) {
                //Confirming subscription for existing subscription
                this.confirmCardPayment();
              } else {
                this.userService.cancelSubscriptionStripe("sphere_cancel", this.userService.userSubscription.base.provider_subscription_id).subscribe();
                //Creating new subscription
                let selectedPrice = this.spherePrices[this.selectedPlan].price;
                let subscribeRequest = this.isConverted
                  ? {
                      is_tax_inclusive: this.isConverted || this.billingInfo.country === "US" ? false : true,
                      sales_channel: "myp_upgrade",
                      price_data: {
                        recurring: {
                          interval: this.selectedPlan.includes("annual") ? "year" : "month",
                        },
                        product: environment.stripe.subscription_product[this.selectedPlan],
                        currency: this.activeCurrency,
                        unit_amount: this.isNoDecimalCurrency(this.activeCurrency) ? selectedPrice : parseInt((selectedPrice * 100).toFixed(0)),
                        tax_behavior: "unspecified",
                      },
                      firstName: this.billingInfo.firstName,
                      lastName: this.billingInfo.lastName,
                      address: {
                        line1: this.billingInfo.address,
                        city: this.billingInfo.city,
                        state: this.billingInfo.state,
                        country: this.billingInfo.country,
                        postal_code: this.billingInfo.zip,
                      },
                      promotion_code: "",
                    }
                  : {
                      is_tax_inclusive: this.isConverted || this.billingInfo.country === "US" ? false : true,
                      sales_channel: "myp_upgrade",
                      price_id: this.spherePrices[this.selectedPlan].id,
                      firstName: this.billingInfo.firstName,
                      lastName: this.billingInfo.lastName,
                      address: {
                        line1: this.billingInfo.address,
                        city: this.billingInfo.city,
                        state: this.billingInfo.state,
                        country: this.billingInfo.country,
                        postal_code: this.billingInfo.zip,
                      },
                      promotion_code: "",
                    };
                this.userService.stripeSubscribe(subscribeRequest).subscribe(
                  (result: any) => {
                    if (result.success && result.data) {
                      if (result.data.invoice) {
                        setTimeout(() => {
                          this.subscriptionResume(result.data.invoice);
                        }, 3000);
                      } else {
                        this.loading = false;
                        this.error = "Please fill out all required fields and double check your credit card info.";
                      }
                    } else {
                      this.loading = false;
                      this.error = "Please fill out all required fields and double check your credit card info.";
                    }
                  },
                  (error) => {
                    this.loading = false;
                    this.error = this.helperService.retrieveErrorMessage(error);
                  }
                );
              }
            }
          }
        });
    }
  }

  subscriptionResume(invoiceData) {
    this.userService
      .subscriptionResume({
        invoice: invoiceData,
        transaction_type: "new",
      })
      .subscribe(
        (result: any) => {
          if (result.success && result.data) {
            this.clientSecret = result.data.clientSecret;
            this.subscriptionId = result.data.subscriptionId;
            this.confirmCardPayment();
          }
        },
        (error) => {
          this.loading = false;
          this.error = this.helperService.retrieveErrorMessage(error);
        }
      );
  }

  confirmCardPayment() {
    this.stripe
      .confirmCardPayment(this.clientSecret, {
        payment_method: {
          card: this.cardNumber,
          billing_details: {
            name: this.billingInfo.firstName + " " + this.billingInfo.lastName,
          },
          metadata: {
            sales_channel: "myp_upgrade",
          },
        },
      })
      .then((response) => {
        if (response.error) {
          this.loading = false;
          this.error = response.error.message ? response.error.message : "Please double check your credit card info and try again.";
        } else {
          this.loadingMsg = "18% done...";
          setTimeout(() => {
            this.loadingMsg = "48% done...";
            this.userService.getSubscriptionProvider(true, false).subscribe((result: any) => {
              this.loadingMsg = "48% done...";
              this.userService.subscriptionDetails(true, result).subscribe(
                (result) => {
                  this.loadingMsg = "65% done...";
                  this.loading = false;
                  this.activeModal.close();
                },
                (error) => {
                  this.userService.logout().subscribe((result) => {
                    this.fbAuth.signOut().then(() => {});
                  });
                }
              );
            });
          }, 3000);
        }
      })
      .catch((error) => {
        this.loading = false;
        this.error = "Please fill out all required fields and double check your credit card info.";
      });
  }
}
